import { render, staticRenderFns } from "./Remote.vue?vue&type=template&id=5e385ab6&scoped=true"
import script from "./Remote.vue?vue&type=script&lang=js"
export * from "./Remote.vue?vue&type=script&lang=js"
import style0 from "./Remote.vue?vue&type=style&index=0&id=5e385ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e385ab6",
  null
  
)

export default component.exports